import { render, staticRenderFns } from "./EvaluationFieldOptionEditorCard.vue?vue&type=template&id=2c5ca902&scoped=true&"
import script from "./EvaluationFieldOptionEditorCard.vue?vue&type=script&lang=js&"
export * from "./EvaluationFieldOptionEditorCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c5ca902",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
installComponents(component, {VCard,VCardText})
